import styled from 'styled-components';
import Icon from 'components/base/Icon';
import { boolPropsToClassNames } from 'common/utils/style.utils';

const StyledInputNumber = styled.div`
  display: flex;
  align-items: center;
  margin: 0 1rem;
`;

const StyledValue = styled.div`
  font-weight: 500;
  font-size: 2rem;
  margin-right: 0.5rem;
`;
const StyledArrows = styled.div`
  height: 100%;
`;
const StyledArrow = styled.div`
  &.isDisabled {
    opacity: 0.2;
  }
  &:hover:not(.isDisabled) {
    cursor: pointer;
    opacity: 0.7;
  }
  & svg {
    transform: rotate(90deg);
  }
`;

const InputNumber = ({ value, min, max, onChange, disabled }) => {
  const isMax = !!max && value === max;
  const isMin = !!min && value === min;

  const onClickUp = () => onChange(value + 1);

  const onClickDown = () => {
    const newValue = value - 1;
    onChange(newValue === 0 ? value : newValue);
  };

  const isIncreaseDisabled = isMax || disabled;
  const isDecreaseDisabled = isMin || disabled;

  return (
    <StyledInputNumber>
      <StyledValue>{value}</StyledValue>
      <StyledArrows>
        <StyledArrow
          {...(!isIncreaseDisabled && { onClick: onClickUp })}
          className={boolPropsToClassNames({ isDisabled: isIncreaseDisabled })}
        >
          <Icon name='ChevronLeft' />
        </StyledArrow>
        <StyledArrow
          {...(!isDecreaseDisabled && { onClick: onClickDown })}
          className={boolPropsToClassNames({ isDisabled: isDecreaseDisabled })}
        >
          <Icon name='ChevronRight' />
        </StyledArrow>
      </StyledArrows>
    </StyledInputNumber>
  );
};

export default InputNumber;
